import { useCallback, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { positionDropdown } from '../../../../common/dropdown'
import useDidUpdateEffect from '../../../../common/hooks/useDidUpdateEffect'
import { Element } from '../../../../common/html/element'
import { debounce } from '../../../../helpers/common'
import { DropdownItem } from '../../../common/DropdownItem'
import { InputCompany } from '../../../common/InputCompany'
import { InputSearchDropdown } from '../../../common/InputSearchDropdown'
import {
  changeFilter,
  selectFilter,
  selectListCompSearchForPersonFilter,
  selectLoading,
} from '../../store/slice'
import { getSearchCompanyForPersonFilter } from '../../store/thunk'

export const SelectCompany = ({
  personRef,
  onCompanyRef,
  onCompanyDropdownRef,
}) => {
  const dispatch = useDispatch()
  const filterPerson = useSelector(selectFilter('filterPerson'))
  const dataSearchCompany = useSelector(selectListCompSearchForPersonFilter)
  const isLoadingSearch = useSelector(
    selectLoading('searchCompForPersonFilter'),
  )
  const locale = useSelector((state) => state.i18n.locale)
  const companyRef = useRef()
  const [inputValue, setInputValue] = useState('')
  const dataSearchFormat = dataSearchCompany.filter(
    (item) => item.organizationId !== filterPerson?.organizationId,
  )

  const handleChangeText = useCallback(
    debounce((value) => {
      dispatch(
        getSearchCompanyForPersonFilter({
          term: value,
          page: 1,
          pageSize: 100,
          minimal: true,
        }),
      )
    }, 700),
    [],
  )

  const handleOnFocus = () => {
    if (!dataSearchCompany.length) {
      handleChangeText(inputValue)
    }
  }

  const handleChoose = (value) => {
    setInputValue(value?.organizationName)
    dispatch(
      changeFilter({
        filterPerson: value,
      }),
    )
  }

  const handleClear = () => {
    setInputValue('')
    dispatch(
      changeFilter({
        filterPerson: {},
      }),
    )
  }

  const renderElement = () => {
    return (
      <InputCompany
        containerStyle={{
          flex: 1,
          width: '100%',
          height: '28px',
        }}
        placeHolder="connectMap.main.FILTER_BY_COMPANY"
        type="text"
        isFilter
        isClear={!!filterPerson?.organizationId}
        onChange={setInputValue}
        value={inputValue}
        handleOnFocus={handleOnFocus}
        handleClear={handleClear}
      />
    )
  }

  const renderDropdown = ({ hideDropdown }) => {
    return (
      <div style={{ zIndex: 13 }}>
        {dataSearchFormat?.map((item) => (
          <DropdownItem
            key={item?.organizationId}
            item={item}
            hideDropdown={hideDropdown}
            handleChoose={handleChoose}
          />
        ))}
      </div>
    )
  }

  const renderNodata = () => {
    return (
      <Element style={{ fontStyle: 'italic', padding: 12 }}>
        <Translate value="connectMap.main.NODATA_SEARCH" dangerousHTML />
      </Element>
    )
  }

  useDidUpdateEffect(() => {
    if (!inputValue.length) {
      dispatch(
        changeFilter({
          filterPerson: {},
        }),
      )
    }
    if (inputValue.length !== 1) {
      handleChangeText(inputValue, locale)
    }
  }, [inputValue, locale])

  useEffect(() => {
    if (onCompanyRef) {
      onCompanyRef(companyRef)
    }
  }, [onCompanyRef])

  return (
    <div className="w100" ref={companyRef}>
      <InputSearchDropdown
        style={{ width: '100%' }}
        renderElement={renderElement}
        renderDropdown={renderDropdown}
        dropdownItemHeight={50}
        maxDropdownItem={10}
        data={dataSearchFormat}
        dropdownPosition={positionDropdown.BOTTOM_CENTER}
        isLoading={isLoadingSearch}
        renderNodata={renderNodata}
        isValidateTwoKey
        textInput={inputValue}
        exceptRef={[personRef, companyRef]}
        onDropdownRef={onCompanyDropdownRef}
      />
    </div>
  )
}
